<template>
  <kst-table action input-mode :data="userItems">
    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip v-if="row.Errors.length > 0" error-mode>
          <template #content>
            <kst-list :items="row.Errors"/>
          </template>
          <kst-icon error-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      field="DispatchName"
      :label="SalesItemCatalog.DispatchName.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="SalesItemCatalog"
        :disabled="row.IsClosed" :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip info-mode>
          <template #content>
            <kst-list info-mode :items="Model.getItemInfo_Edit(row)"/>
          </template>
          <kst-icon info-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-packaging"
      field="PackagingName"
      :label="SalesItemCatalog.PackagingName.Label"
    >
      <template v-if="row.DispatchIsActive && row.QtyInvoice === 0">
        <kst-input error-off field-only
          :field="column.field" :data="row" :catalog="SalesItemCatalog"
          :index="index" :options="row.PackagingOptions"
          @input="handlePackaging(row)" @error="handleRowErrors"
        />
      </template>
      <template v-else>
        <kst-output box-off field-only
          field="Packaging" :data="row" :catalog="SalesItemCatalog"
        />
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-qty"
      field="Qty"
      :label="SalesItemCatalog.Qty.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="SalesItemCatalog"
        :index="index" @input="handleQuantity(row)" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-price-button"
      field="SellPrice"
      :label="SalesItemCatalog.SellPrice.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="SalesItemCatalog"
        :disabled="row.IsClosed" :index="index"
        @input="handleSellPrice(row)" @error="handleRowErrors"
      >
        <template #right>
          <div class="control">
            <kst-tooltip search-mode hover-only
              position="is-bottom"
              :content="SalesItemCatalog.SellPrice.Label"
            >
              <kst-button search-mode @click="handleSearch_Price(index)"/>
            </kst-tooltip>
          </div>
        </template>
      </kst-input>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="Total"
      :label="SalesItemCatalog.Total.Label"
    >
      <kst-output box-off field-only
        :field="column.field" :data="row" :catalog="SalesItemCatalog"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-isclosed"
      field="IsClosed"
      :label="SalesItemCatalog.IsClosed.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="SalesItemCatalog" :index="index"
        :disabled="isNaN(parseInt(row.Qty)) || parseInt(row.Qty) <= row.QtyInvoice"
      />
    </b-table-column>

    <template #action="{ row, index }">
      <template v-if="row.QtyInvoice === 0">
        <kst-tooltip delete-mode hover-only :content="Model.SalesItem.Module.FullName">
          <kst-button delete-mode is-round @click="handleRowDelete(index)"/>
        </kst-tooltip>
      </template>
    </template>

    <template #empty-body>
      <ValidationProvider v-slot="{ errors }" name="userItems" rules="required">
        <kst-error :array-blank-mode="!!errors"/>
      </ValidationProvider>
    </template>
  </kst-table>
</template>

<script>
import DialogMixin from "@/mixins/DialogMixin.js";
import Catalog from "../SalesCatalog.js";
import Info from "../SalesInfo.js";
import SalesItemCatalog from "../SalesItemCatalog.js";
import Model from "../SalesModel.js";

export default {
  mixins: [DialogMixin],
  props: {
    userData: Object,
    userItems: Array
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model,
    SalesItemCatalog: SalesItemCatalog,
    selectedIndex: null
  }),
  methods: {
    handlePackaging(item) {
      Model.updateItem(item);
      Model.updateDetails(this.userData, this.userItems);
    },
    handleQuantity(item) {
      Model.validateItem_Edit(item);
      Model.updateItem(item);
      Model.updateDetails(this.userData, this.userItems);
    },
    handleSellPrice(item) {
      Model.updateItem(item);
      Model.updateDetails(this.userData, this.userItems);
    },

    handleRowDelete(index) {
      this.selectedIndex = index;
      this.showConfirm(
        Info.Message.Edit_ConfirmDeleteItem,
        this.handleRowDelete_Confirm,
        this.handleRowDelete_Cancel
      );
    },
    handleRowDelete_Confirm() {
      this.userItems.splice(this.selectedIndex, 1);
      Model.updateDetails(this.userData, this.userItems);

      this.selectedIndex = null;
    },
    handleRowDelete_Cancel() {
      this.selectedIndex = null;
    },
    handleRowErrors(errors, field, index) {
      Model.setItemErrors(this.userItems[index], field, errors);
    },

    handleSearch_Price(index) {
      this.$emit(this.$kst.Enum.Event.Callback, {
        isPrice: true,
        index: index
      });
    }
  }
}
</script>